import { combineReducers } from 'redux';

const initialState = {

    dashboardGraph : undefined,
    shareData : undefined
};

const overviewData = (state = initialState, action) => {
    switch(action.type){

        case "DASHBOARD_GRAPH_SUCCESS":
            return {
                ...state,
                dashboardGraph : (action.graphData && action.graphData.data) ? action.graphData.data.response:[]
            }
        case "DASHBOARD_SHARE_DATA_SUCCESS":
            return {
                ...state,
                shareData : (action.shareData && action.shareData.data) ? action.shareData.data.response:[]
            }
        default:
            return state;
    }
}


const overview = combineReducers({
    overviewData
})

export default overview;
//export const getOverviewData = state => state.overview.overviewData;



// WEBPACK FOOTER //
// ./src/reducers/overview.js